export const contentsDesktop = [
    {
        id: 1,
        body: 'Compare from wide range of prices from different stores so as to help with your purchase decisions.',
        image:  'fc1.svg'
    },
    {
        id: 2,
        body: 'Get easy access sourcing for available coupons including digital coupons to help save more and buy more.',
        image: 'fc2.svg'
    },
    {
        id: 3,
        body: 'Users  can easily click on links to there preferred stores and get redirected to the exact product of choice.',
        image: 'fc3.svg'
    },
    {
        id: 4,
        body: 'Get Standard description of product prices to get well informed ',
        image: 'fc4.svg'
    },
    {
        id: 5,
        body: 'Availability of verified reviews from registered users based on there purchase  experiences for better decisions ',
        image: 'fc5.svg'
    },
    {
        id: 6,
        body: '...Other features to aid you in your pricing decisions',
        image: 'fc6.svg'
    }
]

export const contentsMobile = [
    {
        id: 1,
        body: 'Compare from wide range of prices from different stores so as to help with your purchase decisions.',
        image:  'fc1m.svg'
    },
    {
        id: 2,
        body: 'Get easy access sourcing for available coupons including digital coupons to help save more and buy more.',
        image: 'fc2m.svg'
    },
    {
        id: 3,
        body: 'Users  can easily click on links to there preferred stores and get redirected to the exact product of choice.',
        image: 'fc3m.svg'
    },
    {
        id: 4,
        body: 'Get Standard description of product prices to get well informed ',
        image: 'fc4m.svg'
    },
    {
        id: 5,
        body: 'Availability of verified reviews from registered users based on there purchase  experiences for better decisions ',
        image: 'fc5m.svg'
    },
    {
        id: 6,
        body: '...Other features to aid you in your pricing decisions',
        image: 'fc6m.svg'
    }
]